import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {fetchCompanyRequested, updateCompanyRequested} from 'services/company/action';
import {onUploadProgress} from 'utils/ComponentUtilFunctions';
import Translate from 'components/Translate';
import TranslateProperty from 'components/TranslateProperty';
import CustomInput from 'components/input-text';
import './index.css';
import SelectWithBorder from 'components/select-with-borders'
import countries from './Countries';
import LoadingComponent from "../../../../../assets/LoadingComponent";
import {validate} from "./validator"
import {updateUserData as updateUserDataAction} from "../../../../../services/user/action";
import BlueButton from "../../../../../components-new/buttons/BlueButton";
import SilverButton from "../../../../../components-new/buttons/SilverButton";
import Input from "../../../../../components-new/Input";
import config from "../../../../../config";
import {endParentCompanyUnmanagedConversationsWithMessage} from "../../../../../services/company/api";
import {silverInfoStyles, tabButtonStyles} from "../../../../../utils/General";
import RedButton from "../../../../../components-new/buttons/RedButton";

const organizationTypes = [
    {value: 'LEGAL', title: 'Legal'},
    {value: 'INDIVIDUAL', title: 'Individual'}
];

const selectStyle = {
    height: '50px',
    boxShadow: 'none',
    border: '1px solid #A4ADC1',
    width: '300px'
};

const selectListStyles = {
    top: '32px',
    maxHeight: '150px',
    overflowY: 'scroll',
    marginTop: '20px',
    marginBottom: '15px',
};

const style = {
    header: {
        fontSize: '16px',
        lineHeight: '20px',
        fontWeight: 'inherit',
        color: '#A4ADC1',
    }
}

const inputSuccessStyles = {width: '300px', height: '50px'};
const inputErrorStyles = {width: '300px', height: '50px', border: '1px solid #E14E52'};
const errorTextStyle = {fontSize: '12px', color: '#E14E52'};


class Index extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            touched: false,
            name: '',
            domain: '',
            image: '',
            uploadingIcon: false,
            uploadPercent: 0,
            organization: {},
            country: {},
            address: '',
            tin: '',
            passport: '',
            loading: true,
            errorMessage: null,
            email: '',
            endChatText: '',
            endMin: 0,
            activeTab: 'company'
        };

        this.onUploadProgress = onUploadProgress.bind(this);
    }

    componentDidMount() {
        const {fetchCompany} = this.props;
        fetchCompany();
        const {user} = this.props;
        this.setState({...user});
    }

    componentDidUpdate(prevProps) {
        const {company} = this.props;
        const {touched} = this.state;
        if (touched) {
            return;
        }

        const {organization, country} = company;
        const organizationValue = organizationTypes.find((item) => (item.value === organization));
        const countryValue = countries.find((item) => (item.value === country));

        if (prevProps.company !== company) {
            this.setState({
                ...company,
                organization: organizationValue === undefined ? {title: ''} : organizationValue,
                country: countryValue === undefined ? {title: ''} : countryValue,
                loading: false
            });
        }
    }

    getCompanyDataFromState = () => {
        const {
            name, domain, image, organization, address, passport, tin, country
        } = this.state;
        const organizationValue = organization.value;
        const countryValue = country.value;
        return {
            name,
            domain,
            image,
            organization: organizationValue,
            country: countryValue,
            address,
            passport,
            tin
        };
    };

    saveCompany = () => {
        const {company, updateCompany} = this.props;
        const companyData = this.getCompanyDataFromState();

        const errorMessage = validate(companyData);
        if (errorMessage != null) {
            this.setState({errorMessage: errorMessage});
            return;
        } else {
            this.setState({errorMessage: errorMessage});
        }

        Object.assign(companyData, {
            nlpEnabled: company.nlpEnabled,
            status: company.status,
        });
        updateCompany(companyData)
    };

    cancel = () => {
        const {company} = this.props;

        const {organization, country} = company;
        const organizationValue = organizationTypes.find((item) => (item.value === organization));
        const countryValue = countries.find((item) => (item.value === country));

        this.setState({
            ...company,
            organization: organizationValue === undefined ? {title: ''} : organizationValue,
            country: countryValue === undefined ? {title: ''} : countryValue,
        });
    };

    handleChange = name => (value) => {
        this.setState({
            [name]: value,
            touched: true,
        });
    };

    handleOrganizationDropdownSelect = (select) => {
        this.setState({
            organization: select,
            touched: true,
            errorMessage: null,
        })
    };

    handleEndAndSendClick = () => {
        const {company, addNotification} = this.props;
        const {endChatText, endMin} = this.state;

        if (this.state.endChatText === '') {
            addNotification('textMustNotBeEmpty', config.notificationLevels.error);
            return;
        }

        endParentCompanyUnmanagedConversationsWithMessage(company.id, endChatText, endMin)
            .then(() => {
                addNotification('successful', config.notificationLevels.success);
                this.setState({endChatText: ''})
                this.setState({endMin: 0})
            })
            .catch(() => {
                addNotification('somethingWentWrong', config.notificationLevels.error);
            })
    }

    render = () => {
        const {
            name, loading, organization, country, address, tin, passport, errorMessage, endChatText, endMin, activeTab
        } = this.state;

        const {company: {editing}, commonStyles, company} = this.props;
        const {tariff} = company;
        const features = tariff.features

        const inputStyle = errorMessage ? inputErrorStyles : inputSuccessStyles;

        if (loading) {
            return (<LoadingComponent/>)
        }

        return (
            <div>
                <div style={tabButtonStyles.tabButtons}>
                    <button style={tabButtonStyles.tabButton(activeTab === 'company')}
                            onClick={() => this.setState({activeTab: 'company'})}>
                        <Translate text="company"/>
                    </button>
                    {features.includes(config.features.END_UNMANAGED_CHATS) && (
                        <button style={tabButtonStyles.tabButton(activeTab === 'chats')}
                                onClick={() => this.setState({activeTab: 'chats'})}>
                            <Translate text="chats"/>
                        </button>
                    )}
                </div>

                <div style={{padding: '32px', width: '100%'}}>
                    {activeTab === 'company' && (
                        <div className={'bg-white'} style={{padding: '32px'}}>
                            <div style={{display: 'flex'}}>
                                <div style={{marginRight: '60px'}}>
                                    <div className="flex-wrapper">
                                        <div className="workspace-name">
                                            <h3 style={commonStyles.smallTitle}>
                                                <Translate text="companyName"/>
                                            </h3>
                                            <TranslateProperty
                                                properties={[{key: 'placeholder', value: 'companyName'}]}>
                                                <CustomInput controlled handleChange={this.handleChange('name')}
                                                             value={name}
                                                             inputStyles={{width: '420px', height: '50px'}}
                                                />
                                            </TranslateProperty>

                                            <h3 style={commonStyles.smallTitle}>
                                                <Translate text="organizationType"/>
                                            </h3>
                                            <SelectWithBorder
                                                options={organizationTypes}
                                                toggleSelected={this.handleOrganizationDropdownSelect}
                                                selected={organization}
                                                defaultTitle={organization.title}
                                                listStyles={selectListStyles}
                                                wrapperStyles={selectStyle}/>
                                            <h3 style={commonStyles.smallTitle}>
                                                <Translate text="country"/>
                                            </h3>
                                            <CustomInput
                                                controlled
                                                disabled={true}
                                                value={country.title}
                                                inputStyles={inputStyle}/>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <h3 style={commonStyles.smallTitle}>
                                            <Translate text="address"/>
                                        </h3>
                                        <CustomInput controlled handleChange={this.handleChange('address')}
                                                     value={address}
                                                     inputStyles={inputSuccessStyles}/>
                                    </div>
                                    {
                                        country.value === 'am' && organization.value === 'LEGAL' && <div>
                                            <h3 style={commonStyles.smallTitle}>
                                                <Translate text="tin"/>
                                            </h3>
                                            <CustomInput controlled handleChange={this.handleChange('tin')} value={tin}
                                                         maxLength={8}
                                                         inputStyles={inputStyle}/>
                                        </div>
                                    }
                                    {
                                        country.value === 'am' && organization.value === 'INDIVIDUAL' && <div>
                                            <h3 style={commonStyles.smallTitle}>
                                                <Translate text="passport"/>
                                            </h3>
                                            <CustomInput controlled handleChange={this.handleChange('passport')}
                                                         value={passport}
                                                         maxLength={9}
                                                         inputStyles={inputStyle}/>
                                        </div>
                                    }
                                    {
                                        errorMessage &&
                                        <span style={errorTextStyle}><Translate text={errorMessage}/></span>
                                    }
                                </div>
                            </div>
                            <div className="company-save-buttons">
                                <SilverButton
                                    styles={{marginRight:'20px'}}
                                    type={'button'}
                                    onClick={this.cancel}
                                    width={'130px'}
                                    children={<Translate text="cancel"/>}
                                />
                                <BlueButton
                                    type={'button'}
                                    onClick={this.saveCompany}
                                    width={'140px'}
                                    children={<Translate text="save"/>}
                                />
                            </div>
                        </div>
                    )}

                    {activeTab === 'chats'
                        && (tariff.status === config.tariffStatusMap.active
                            || tariff.status === config.tariffStatusMap.trial)
                        && (features.includes(config.features.END_UNMANAGED_CHATS)) && (
                            <div className={'bg-white'} style={{padding: '32px'}}>
                                <div style={{display: 'flex', flexDirection: 'column', gap: '20px'}}>
                                    <h2 style={{...silverInfoStyles.info, marginLeft: '0px'}}>
                                        <Translate text="chatsFunctionInfo"/>
                                    </h2>

                                    <Input
                                        type="number"
                                        name="interval"
                                        value={endMin}
                                        style={{width: '100px'}}
                                        onChange={(e) => this.setState({endMin: e.target.value})}
                                        min={0}
                                    />

                                    <TranslateProperty properties={[{key: 'placeholder', value: 'message'}]}>
                                        <Input value={endChatText}
                                               onChange={(e) => this.setState({endChatText: e.target.value})}
                                               isTextarea={true}
                                        />
                                    </TranslateProperty>

                                    <BlueButton onClick={this.handleEndAndSendClick} width={'300px'} type={'button'}>
                                        <Translate text="saveAndEnd"/>
                                    </BlueButton>
                                </div>

                            </div>
                        )}
                </div>

            </div>
        );
    };
}

Index.propTypes = {
    user: PropTypes.object.isRequired,
    updateUserData: PropTypes.func.isRequired,
    company: PropTypes.object.isRequired,
    fetchCompany: PropTypes.func.isRequired,
    updateCompany: PropTypes.func.isRequired,
    commonStyles: PropTypes.shape({
        wrapper: PropTypes.object.isRequired,
        title: PropTypes.object.isRequired,
        smallTitle: PropTypes.object.isRequired,
    }).isRequired,
};

const mapStateToProps = state => ({
    company: state.company,
    user: state.user
});

const mapDispatchToProps = dispatch => ({
    fetchCompany: () => {
        dispatch(fetchCompanyRequested());
    },
    updateCompany: (companyInfo) => {
        dispatch(updateCompanyRequested(companyInfo));
    },
    updateUserData: updateUserDataAction,
});


export default connect(mapStateToProps, mapDispatchToProps)(Index);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/company/index.jsx